import api from './api';

export interface Fazenda {
  id?: number;
  socio_id?: number | null;
  nome_socio?: string | null;
  nome_fazenda: string;
  proprietario_responsavel?: string;
  proprietario_rg?: string;
  cpf?: string;
  endereco?: string;
  cidade?: string;
  estado?: string;
  telefone?: string;
  car?: string;
  latitude?: string;
  longitude?: string;
  observacoes?: string;
  data_cadastro?: string;
}

export interface FazendaCreate extends Omit<Fazenda, 'id' | 'data_cadastro'> {}

export const fazendaService = {
  async listar(params?: {
    skip?: number;
    limit?: number;
    busca?: string;
  }): Promise<Fazenda[]> {
    const response = await api.get<Fazenda[]>('/api/fazendas/', { params });
    return response.data;
  },

  async obter(id: number): Promise<Fazenda> {
    const response = await api.get<Fazenda>(`/api/fazendas/${id}`);
    return response.data;
  },

  async criar(fazenda: FazendaCreate): Promise<Fazenda> {
    const response = await api.post<Fazenda>('/api/fazendas/', fazenda);
    return response.data;
  },

  async atualizar(id: number, fazenda: Partial<Fazenda>): Promise<Fazenda> {
    const response = await api.put<Fazenda>(`/api/fazendas/${id}`, fazenda);
    return response.data;
  },

  async deletar(id: number): Promise<void> {
    await api.delete(`/api/fazendas/${id}`);
  },
};
